import type { DateTime } from '#layers/data-model/public';
import { compareValues } from './compare-values';

export type WorkspaceSortField = 'title' | 'dateCreated' | 'dateUpdated';
export type WorkspaceSortDirection = 'asc' | 'desc';

export interface WorkspaceSortState {
	field: WorkspaceSortField;
	direction: WorkspaceSortDirection;
}

export interface Sortable {
	title: string;
	workspace: {
		dateCreated: DateTime | null;
		dateUpdated: DateTime | null;
	};
}

export function sortWorkspaces<T extends Sortable>(items: T[], state: WorkspaceSortState): T[] {
	const { field, direction } = state;

	return items.toSorted((a, b) => {
		if (field === 'title') {
			const cmp = a.title.localeCompare(b.title);
			return direction === 'asc' ? cmp : -cmp;
		}

		const dateA = a.workspace[field];
		const dateB = b.workspace[field];

		if (dateA === null && dateB === null) return 0;
		if (dateA === null) return 1;
		if (dateB === null) return -1;

		const cmp = compareValues(dateA, dateB);
		return direction === 'asc' ? cmp : -cmp;
	});
}
